export default __webpack_public_path__ + "static/media/twitter.7880457c.svg";